module.exports = __webpack_public_path__ + "img/push.80d8b492.jpg";